import { createContext, Dispatch } from 'react';
import State, { Initial } from './state';
import Action from './action';

export const DispatchContext = createContext<Dispatch<Action>>(() => {});

// eslint-disable-next-line unicorn/no-useless-undefined
export const StateContext = createContext<State>(Initial);
